export enum AppType {
  Organizations,
  Admins,
}
